import { EnvironmentVariable } from '../constants/env'
import { getEnvVar } from './env'

export const getMfeBundleUrl = (port: string, appName: string) => {
  const script = `${appName}-feature-app.federated.js`
  if (process.env.NODE_ENV === 'development') {
    return `http://${window.location.hostname}:${port}/${script}`
  } else {
    const bundleUrl = `${getEnvVar(EnvironmentVariable.PUBLIC_PATH)}/container/mfes/${script}`
    const buildId = getEnvVar(EnvironmentVariable.MFE_BUILD_ID)
    // `script` above is a fixed, unhashed filename (webpack can't content-hash the
    // Module Federation entry chunk without a runtime manifest lookup), so a browser
    // that cached it from a previous deploy can keep serving stale bytes against a
    // container that has already moved on. Busting on the current build id forces a
    // fresh fetch every deploy instead of relying on cache revalidation. If the build
    // id is unset, skip the param rather than caching on the literal string "undefined".
    return buildId ? `${bundleUrl}?v=${buildId}` : bundleUrl
  }
}
